import { MAPI_URL } from './serverStore';

async function readResponse(response) {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

export async function printSampleLabel(sample) {
  if (!sample) throw new Error('No sample is selected.');

  const response = await fetch(`${MAPI_URL}/print-label`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      sampleId: sample.id,
      workOrder: sample.workOrder,
      source: sample.source || sample.client || '',
      description: sample.desc || '',
      received: sample.received || '',
    }),
  });
  const result = await readResponse(response);
  if (!response.ok || !result.success) {
    throw new Error(result.error || 'The Windows label agent could not print this label.');
  }
  return result;
}
